// extracted by mini-css-extract-plugin
export default {"headline":"Header_headline__hTpus","headlineTitle":"Header_headlineTitle__+aEgx","breadcrumbs":"Header_breadcrumbs__U-WYf"};